import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { RestaurantServiceService } from '../../restaurant/restaurant-service.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-meal-detail',
  templateUrl: './meal-detail.component.html',
  styleUrls: ['./meal-detail.component.scss']
})
export class MealDetailComponent implements OnInit {
  uploadForm: FormGroup;
  myForm: FormGroup;
  private id;
  private Id;

  private restId;
  private menuId;
  spin = false;
  stotal;
  p = 5;
  p1 = 1;
  p2 = 1;
  p3 = 1;
  modalRef: BsModalRef;
  addons: any = [];
  scale: any = [];
  ingredient: any = [];
  addOnModel: any  = {};
  addingrediantsModel: any = {};
  addScalemodel: any = {};
  hidemeal = false;
  hideingredient = true;
  hideaddon = true;
  hidescale = true;
  meal: any = {};
  customOption: any = [];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private restaurantServices: RestaurantServiceService,
    private formBuilder: FormBuilder,

  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.params['id'];
    this.restId = this.route.snapshot.params['restId'];
    this.menuId = this.route.snapshot.params['menuId'];
    this.customMeal();
    this.mealScale();
    this.mealIngredient();
    this.mealAddon();
    this.uploadForm = this.formBuilder.group({
      file: ['']
    });
  }


  customMeal() {
    this.restaurantServices.GETCustomMeal(this.id).subscribe(Response => {
      this.spin = true;
      console.log('consol response of meal detail test,,,,,,', Response);
      this.meal = Response['Meal'];
      this.customOption = Response['CustomOptions'];

      console.log('custom meal response', this.customOption);
    });
  }
  mealAddon() {
    this.restaurantServices.GETMealAddon(this.id).subscribe(Response => {
      this.spin = true;
      this.addons = Response;
      // console.log('ingredient test,,,,,,', Response);
    });
  }
  mealScale() {
    this.restaurantServices.GETMealScale(this.id).subscribe(Response => {
      this.spin = true;
      this.scale = Response;
      this.stotal = this.scale.length;
      console.log('total', this.stotal);
      console.log('scale test,,,,,,', Response);
    });
  }
  mealIngredient() {
    this.restaurantServices.GETMealIngredient(this.id).subscribe(Response => {
      this.spin = true;
      this.ingredient = Response;
      // console.log('ingredient test,,,,,,', Response);
    });
  }
  decline(): void {
    // this.message = 'Declined!';
    this.modalRef.hide();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-lg'});
 }
 openDeleteModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(template, {class: 'modal-sm'});
}
  gotoMeal() {
   this.hidemeal = false;
    this.hideingredient = true;
    this.hideaddon = true;
    this.hidescale = true;
  }

  gotoAddon() {
    this.hidemeal = true;
     this.hideingredient = true;
     this.hideaddon = false;
     this.hidescale = true;
   }

   gotoIngredient() {
    this.hidemeal = true;
     this.hideingredient = false;
     this.hideaddon = true;
     this.hidescale = true;
   }

   gotoScale() {
    this.hidemeal = true;
     this.hideingredient = true;
     this.hideaddon = true;
     this.hidescale = false;
   }
// Addons
addAdones() {
  this.addOnModel.MealId = this.id;

  console.log(this.addOnModel);
    this.restaurantServices.CreateAddOn(this.addOnModel).subscribe((Data: any) => {
      this.mealAddon();

    this.modalRef.hide();
    // console.log('meal added data', Data);
    }, error => {

    });
}
deteteAddon(id): void {
  this.restaurantServices.DeleteAddon(id).subscribe(Response => {
    // console.log('Response Delete API', Response);
    this.customMeal();
  });
  this.modalRef.hide();
}


// Ingredient
adddIngredient() {
    this.addingrediantsModel.MealId = this.id;
    console.log(this.addingrediantsModel);
      this.restaurantServices.CreateIngrediants(this.addingrediantsModel).subscribe((Data: any) => {
        this.mealIngredient();

        this.modalRef.hide();
          //  console.log("meal Ingrediants added data", Data);
      }, error => {
      });

  }
  deleteIngredient(id): void {
    debugger;
    this.restaurantServices.DeleteIngredient(id).subscribe(Response => {
      // console.log('Response Delete API', Response);
      this.mealIngredient();
    });
    this.modalRef.hide();
  }
  // add scale
  addScale() {
    this.addScalemodel.MealId = this.id;
    // console.log(this.addScalemodel);
      this.restaurantServices.CreateScale(this.addScalemodel).subscribe((Data: any) => {
        this.mealScale();

        this.modalRef.hide();
           console.log('meal scale added data', Data);
      }, error => {
      });

  }
  deleteScale(id): void {
    debugger;
    this.restaurantServices.DeleteScale(id).subscribe(Response => {
      // console.log('Response Delete API', Response);
      this.mealScale();
    });
    this.modalRef.hide();
  }

  UpdateMealScale(id) {
    this.router.navigateByUrl('/updateScale/' + this.restId + '/' + this.menuId + '/' + this.id + '/' + id);

  }

  UpdateMealAddOns(id) {
    this.router.navigateByUrl('/updateAddon/' + this.restId + '/' + this.menuId + '/' + this.id  + '/' + id);
  }
  UpdateMealIngrediants(id) {
    this.router.navigateByUrl('/updateIngrediant/' + this.restId + '/' + this.menuId + '/' + this.id  + '/' + id);
  }
  ScaleUnit(id) {
    this.router.navigateByUrl('/mealDetail/scale/' + this.restId + '/' +  this.menuId + '/' + this.id  + '/' + id);
  }
  IngrdientType(id) {
    this.router.navigateByUrl('/mealDetail/ingrediant/' + this.restId + '/' +  this.menuId + '/' + this.id  + '/' + id);
  }
  uploadFileInput(event, id) {
    debugger;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      // this.show=true;
      this.uploadForm.get('file').setValue(file);

      const formData = new FormData();
      formData.append('file', this.uploadForm.get('file').value);
      formData.append('Id', id.toString());
      this.restaurantServices.MealImageUpload(formData).subscribe((Data: any) => {
        this.customMeal();
      });
    }
  }
}
